module.exports = __webpack_public_path__ + "img/banner.0ccae3d6.png";